import React from "react";
import Button from "react-bootstrap/Button";
import FormInput from "./FormInput";
import { useLang } from "../context/lang";
import { useStudents } from "../context/students";
import { defaultDateRangeLastDays } from "../utils/dateRange";

const StudentsDateRange = () => {
  const { t } = useLang();
  const { dateRange, setDateRange } = useStudents();

  return (
    <div className="width-create-Major rounded-lg p-16 mt-16 bg-white shadow-sm">
      <div className="d-flex flex-wrap align-items-end">
        <FormInput
          id="students-from-date"
          label={t("fromDate")}
          value={dateRange.from}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setDateRange((prev) => ({ ...prev, from: e.target.value }))
          }
          type="date"
          required
          width="50%"
          className="pr-8"
        />
        <FormInput
          id="students-to-date"
          label={t("toDate")}
          value={dateRange.to}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setDateRange((prev) => ({ ...prev, to: e.target.value }))
          }
          type="date"
          required
          width="50%"
        />
        <div className="w-100 mt-8 d-flex justify-content-end">
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => setDateRange(defaultDateRangeLastDays(7))}
          >
            {t("last7Days")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StudentsDateRange;
